export default theme => ({
  password: {
    width: 350,
    marginBottom: 15
  },
  backToSignIn: {
    fontSize: 11
  },
  passwordLabel: {
    marginTop: 24,
    marginBottom: 10,
    fontSize: 18,
    color: theme.grey2
  }
});
